import { post, route } from 'remix/routes'

export const routes = route({
	home: '/',
	connectOauth: '/connect/oauth',
	integrationLogo: '/integrations/logos/:integrationSlug',
	accountIntegrations: '/account/integrations',
	// More specific than `:integrationName` so a connection named `apps` still
	// resolves at `/account/integrations/apps` while OAuth apps live under
	// `/account/integrations/apps/:appSlug`.
	accountOauthAppDetail: '/account/integrations/apps/:appSlug',
	accountIntegrationDetail: '/account/integrations/:integrationName',
	accountIntegrationsApi: '/account/integrations.json',
	accountIntegrationsApiPost: post('/account/integrations.json'),
	accountMcpServers: '/account/mcp-servers',
	accountMcpServerNew: '/account/mcp-servers/new',
	accountMcpServerDetail: '/account/mcp-servers/:serverId',
	accountMcpServersOauthCallback: '/account/mcp-servers/oauth/callback',
	accountMcpServersApi: '/account/mcp-servers.json',
	accountMcpServersApiPost: post('/account/mcp-servers.json'),
	accountPackageInvocationTokens: '/account/package-invocation-tokens',
	accountPackageInvocationTokenNew: '/account/package-invocation-tokens/new',
	accountPackageInvocationTokenDetail:
		'/account/package-invocation-tokens/:tokenId',
	accountPackageInvocationTokensApi: '/account/package-invocation-tokens.json',
	accountPackageInvocationTokensApiPost: post(
		'/account/package-invocation-tokens.json',
	),
	accountPackages: '/account/packages',
	accountPackageDetail: '/account/packages/:packageId',
	accountPackagesApi: '/account/packages.json',
	accountRemoteConnectors: '/account/remote-connectors',
	accountRemoteConnectorNew: '/account/remote-connectors/new',
	accountRemoteConnectorDetail: '/account/remote-connectors/:connectorId',
	accountRemoteConnectorsApi: '/account/remote-connectors.json',
	accountRemoteConnectorsApiPost: post('/account/remote-connectors.json'),
	accountSecrets: '/account/secrets',
	accountSecretNew: '/account/secrets/new',
	accountSecretUserDetail: '/account/secrets/user/:secretName',
	accountSecretSessionDetail: '/account/secrets/session/:sessionId/:secretName',
	accountSecretPackageDetail: '/account/secrets/package/:packageId/:secretName',
	accountSecretsApprove: '/account/secrets/approve',
	accountSecretsApi: '/account/secrets.json',
	accountSecretsApiPost: post('/account/secrets.json'),
	accountValues: '/account/values',
	accountValueNew: '/account/values/new',
	accountValueDetail: '/account/values/:valueId',
	accountValuesApi: '/account/values.json',
	accountValuesApiPost: post('/account/values.json'),
	accountJobs: '/account/jobs',
	accountJobDetail: '/account/jobs/:jobId',
	accountJobsApi: '/account/jobs.json',
	accountJobsApiPost: post('/account/jobs.json'),
	accountActivity: '/account/activity',
	accountActivityDetail: '/account/activity/:runId',
	accountActivityApi: '/account/activity.json',
	accountMemories: '/account/memories',
	accountMemoryDetail: '/account/memories/:memoryId',
	accountMemoriesApi: '/account/memories.json',
	accountMemoriesApiPost: post('/account/memories.json'),
	accountEmail: '/account/email',
	accountEmailDetail: '/account/email/:messageId',
	accountEmailApi: '/account/email.json',
	accountConnectionsApi: '/account/connections.json',
	accountConnectionsApiPost: post('/account/connections.json'),
	accountPasskeys: '/account/passkeys',
	accountPasskeysApi: '/account/passkeys.json',
	accountPasskeysApiPost: post('/account/passkeys.json'),
	accountProfileApi: '/account/profile.json',
	accountProfileApiPost: post('/account/profile.json'),
	accountAvatarApiPost: post('/account/profile/avatar.json'),
	accountTwoFactor: '/account/two-factor',
	accountTwoFactorApi: '/account/two-factor.json',
	accountTwoFactorApiPost: post('/account/two-factor.json'),
	accountBilling: '/account/billing',
	accountBillingApi: '/account/billing.json',
	accountBillingCheckoutPost: post('/account/billing/checkout.json'),
	accountBillingSuccess: '/account/billing/success',
	accountBillingPortal: '/account/billing/portal',
	accountUsage: '/account/usage',
	accountUsageApi: '/account/usage.json',
	accountEmailChange: post('/account/email-change.json'),
	accountResendVerification: post('/account/resend-verification.json'),
	accountExport: '/account/export.json',
	admin: '/admin',
	adminUsers: '/admin/users',
	adminUserDetail: '/admin/users/:stableUserId',
	adminUsersApi: '/admin/users.json',
	adminUsersApiPost: post('/admin/users.json'),
	adminRoles: '/admin/roles',
	adminRolesApi: '/admin/roles.json',
	adminInvites: '/admin/invites',
	adminInvitesApi: '/admin/invites.json',
	adminInvitesApiPost: post('/admin/invites.json'),
	adminFeatureFlags: '/admin/feature-flags',
	adminFeatureFlagsApi: '/admin/feature-flags.json',
	adminFeatureFlagsApiPost: post('/admin/feature-flags.json'),
	adminPlatformIntegrations: '/admin/platform-integrations',
	adminPlatformIntegrationNew: '/admin/platform-integrations/new',
	adminPlatformIntegrationDetail: '/admin/platform-integrations/:slug',
	adminPlatformIntegrationsApi: '/admin/platform-integrations.json',
	adminPlatformIntegrationsApiPost: post('/admin/platform-integrations.json'),
	adminCodemods: '/admin/codemods',
	adminCodemodsApi: '/admin/codemods.json',
	adminCodemodsRunApi: post('/admin/codemods/run.json'),
	adminCodemodsRunStopApi: post('/admin/codemods/run/stop.json'),
	adminCommunityReports: '/admin/community-reports',
	adminCommunityReportsApi: '/admin/community-reports.json',
	adminCommunityReportsApiPost: post('/admin/community-reports.json'),
	adminUserUsageApi: '/admin/users/usage.json',
	adminInsights: '/admin/insights',
	adminInsightsApi: '/admin/insights.json',
	adminPlatformFeedback: '/admin/platform-feedback',
	adminPlatformFeedbackApi: '/admin/platform-feedback.json',
	adminSystemEmail: '/admin/system-email',
	adminSystemEmailApi: '/admin/system-email.json',
	blog: '/blog',
	blogApi: '/blog.json',
	blogRss: '/blog/rss.xml',
	blogPost: '/blog/:slug',
	blogPostApi: '/blog/:slug.json',
	blogPostMarkdown: '/blog/:slug.md',
	blogPostOgImage: '/blog/:slug/og.png',
	guides: '/guides',
	guidesApi: '/guides.json',
	guidesMarkdown: '/guides.md',
	guideDetail: '/guides/:slug',
	guideDetailApi: '/guides/:slug.json',
	guideDetailMarkdown: '/guides/:slug.md',
	community: '/community',
	communityApi: '/community.json',
	communityDetail: '/community/:listingId',
	communityDetailApi: '/community/:listingId.json',
	communityDetailIcon: '/community/:listingId/icon/:iconCommit',
	communityDetailOgImage: '/community/:listingId/og.png',
	communityReportApiPost: post('/community/:listingId/report.json'),
	communityTrustApiPost: post('/community/:listingId/trust.json'),
	communityFeatureApiPost: post('/community/:listingId/feature.json'),
	communityInstallApiPost: post('/community/:listingId/install.json'),
	communityStarApiPost: post('/community/:listingId/star.json'),
	communityStargazersApi: '/community/:listingId/stargazers.json',
	profile: '/@:username',
	// Canonical public URL for a published package, keyed by its owner and
	// `kody.id` (`/@kentcdodds/devin`) rather than the listing uuid. Kept a leaf
	// route: the `/@:username/…` namespaces handled before this router
	// (`packages`, `connectors`, `webhooks`, `api`) all match on the second
	// segment, so any deeper package route would sit at their depth.
	communityPackage: '/@:username/:kodyId',
	// JSON companion lives under `/profiles/…` with the other username-keyed
	// APIs, keeping the `/@…` namespace to human-shareable page URLs.
	communityPackageApi: '/profiles/:username/packages/:kodyId.json',
	profileApi: '/profiles/:username.json',
	profileAvatar: '/profiles/:username/avatar/:cacheKey',
	profileOgImage: '/profiles/:username/og.png',
	profileFollowApiPost: post('/profiles/:username/follow.json'),
	webhookIngress: post(
		'/@:username/webhooks/:packageKodyId/:webhookName/:urlSecret',
	),
	stripeWebhook: post('/webhooks/stripe'),
	timeline: '/timeline',
	timelineApi: '/timeline.json',
	health: '/health',
	healthComponents: '/health/components',
	sentryTunnel: post('/sentry-tunnel'),
	login: '/login',
	ogPageImage: '/og/:page.png',
	pricing: '/pricing',
	privacy: '/privacy',
	terms: '/terms',
	onboarding: '/onboarding',
	onboardingApi: '/onboarding.json',
	onboardingChecklistDismissPost: post('/onboarding/checklist-dismiss.json'),
	resetPassword: '/reset-password',
	verify: '/verify',
	verifyTwoFactorApi: post('/verify/2fa.json'),
	verifyEmail: '/verify-email',
	verifyEmailChange: '/verify-email-change',
	pendingVerification: '/pending-verification',
	signup: '/signup',
	waitingList: post('/waiting-list'),
	account: '/account',
	accountStars: '/account/stars',
	accountStarsApi: '/account/stars.json',
	accountDelete: post('/account/delete'),
	auth: post('/auth'),
	authProvidersApi: '/auth/providers.json',
	authProviderStart: post('/auth/:provider'),
	authProviderCallback: '/auth/:provider/callback',
	session: '/session',
	logout: post('/logout'),
	passwordResetRequest: post('/password-reset'),
	passwordResetConfirm: post('/password-reset/confirm'),
	webauthnRegistration: '/webauthn/registration',
	webauthnRegistrationPost: post('/webauthn/registration'),
	webauthnAuthentication: '/webauthn/authentication',
	webauthnAuthenticationPost: post('/webauthn/authentication'),
})
